import React from 'react'
import ForgotPassword from '../components/ForgotPassword/ForgotPassword'

const ForgotPage = () => {
  return (
    <ForgotPassword/>
  )
}

export default ForgotPage